<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>棋盘事件修改</span>
          <el-row :gutter="10" class="mb8" style="margin-top: 20px;">
            <el-col :span="1.5">
              <el-upload
                ref="upload"
                class="upload-demo"
                :action="sys_app_logoAction"
                accept="xlsx"
                :limit="1"
                :on-success="importUploadSuccess"
                :headers="headers"
              >
                <el-button v-permisaction="['config:slotEventCfg:import']" :loading="loading" icon="el-icon-upload2" size="mini" type="primary">导入</el-button>
              </el-upload>
            </el-col>

            <el-col :span="1.5">
              <el-button
                v-permisaction="['config:slotEventCfg:export']"
                type="primary"
                icon="el-icon-download"
                size="mini"
                @click="exportData"
              >导出</el-button>
            </el-col>

            <el-col :span="1.5">
              <clear-cache-apply />
              <!--              <el-button v-permisaction="['config:slotEventCfg:add']" size="mini" type="warning" @click="onSubmit()">保存</el-button>-->
            </el-col>
          </el-row>

        </div>

        <el-table :data="formData" border stripe>
          <el-table-column prop="levelId" label="等级">
            <template v-slot:default="scope">
              <span>{{ scope.row.levelId }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="v" label="打">
            <template v-slot:default="scope">
              <span>{{ scope.row.pro[0].event[0].v }}</span>
              <br>
              <span>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="v" label="偷">
            <template v-slot:default="scope">
              <span>{{ scope.row.pro[0].event[1].v }}</span>
              <br>
              <span>-</span>
            </template>
          </el-table-column>
          <el-table-column v-for="(v,i) in numbers" :key="i" prop="v" :label="headerTitle[i]">
            <template v-slot:default="scope">
              <span v-if="v <=0">
                <span>{{ scope.row.pro[i] ? scope.row.pro[i].v : 0 }}</span>
                <br>
                <span>-</span>
              </span>
              <span v-else>
                <span>{{ scope.row.pro[i].v }}</span>
                <br>
                <span>{{ scope.row.pro[i].event[0].rewardNum }}</span>
                <br>
                <span v-if="i === '16'">{{ scope.row.pro[i].event[0].v }}</span>
                <span v-else>-</span>
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="pro" label="事件操作">
            <template v-slot:default="scope">
              <el-form :inline="true">
                <el-button type="text" @click="dialogFormVisibleArr[scope.$index].visible = true">事件操作</el-button>
                <el-drawer title="事件操作" :before-close="(d)=>{return handleClose(d, scope.$index)}" size="700px" :visible="dialogFormVisibleArr[scope.$index].visible" @close="confirm(scope.$index)">
                  <el-row v-for="(pro, pIndex) in scope.row.pro" :key="pIndex" style="margin-top: 10px;">
                    <el-form-item label="类型">
                      <el-select v-model="pro.type" placeholder="请选择类型" @change="(v)=>{selectTypeChange(v,scope.$index, pIndex)}">
                        <el-option v-for="(item, index) in selectType" :key="index" disabled :label="item.title" :value="item.id" />
                      </el-select>
                    </el-form-item>
                    <el-form-item label="事件操作">
                      <el-button type="text" @click="dialogEventFormVisibleArr[scope.$index][pIndex]['visible'] = true">编辑</el-button>
                      <el-dialog title="事件" width="750px" :visible.sync="dialogEventFormVisibleArr[scope.$index][pIndex].visible" append-to-body>
                        <el-form :inline="true">
                          <el-row v-for="(e,i) in pro.event" :key="i">
                            <el-form-item style="margin-top: 10px;" label="事件ID">
                              <el-input v-model.number="e.eventId" readonly style="width: 100px" autocomplete="off" />
                            </el-form-item>
                            <el-form-item style="margin-top: 10px;" :label="getVTitle(e.eventId)">
                              <el-input v-model.number="e.v" :readonly="weightIsReadOnly(e.eventId)" style="width: 100px" autocomplete="off" />
                            </el-form-item>
                            <el-form-item label="奖励类型" style="margin-top: 10px;">
                              <el-select v-model.number="e.rewardId" :disabled="isDisabled(e.eventId)" style="width: 100px" placeholder="请选择">
                                <el-option
                                  v-for="(item, index) in rewardType"
                                  :key="index"
                                  :label="item.label"
                                  :value="item.value"
                                  :disabled="item.disabled"
                                />
                              </el-select>
                            </el-form-item>
                            <el-form-item label="奖励数量" style="margin-top: 10px;">
                              <el-input v-model.number="e.rewardNum" :readonly="isReadOnly(e.eventId)" style="width: 100px" placeholder="奖励数量" />
                            </el-form-item>
                          </el-row>
                        </el-form>
                        <div slot="footer" class="dialog-footer">
                          <el-button @click="dialogEventFormVisibleArr[scope.$index][pIndex].visible = false">取 消</el-button>
                          <el-button type="primary" @click="dialogEventFormVisibleArr[scope.$index][pIndex].visible = false">确 定</el-button>
                        </div>
                      </el-dialog>
                    </el-form-item>
                    <el-form-item label="权重">
                      <el-input v-model.number="pro.v" style="width: 100px" placeholder="权重" />
                    </el-form-item>
                  </el-row>
                </el-drawer>
              </el-form>
            </template>
          </el-table-column>

        </el-table>
        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables"
        />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import Vue from 'vue'
import {
  getChessBoardType,
  getRewardType,
  importSlotWeightCfg,
  exportSlotWeightCfgMoney,
  getSlotEventCfgList, updateSlotEventCfg, importSlotWeightEventCfg, exportSlotWeightEventCfg
} from '@/api/config/slot'
import { getToken } from '@/utils/auth'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
export default {
  name: 'ChessBoardEvent',
  components: { ClearCacheApply },
  data() {
    return {
      headerTitle: ['', '体力',	'金币1',	'金币2',	'金币3',	'金币4', '金币5', '金币6',	'金币7',	'金币8',	'起点',	'税收',	'罚款', '随机卡',	'社交奖励', '飞艇',	'免费商店',	'灯泡', '水管', '三角格子', '搭桥快跑', '捡钱快跑', '搭桥小玩法'],
      numbers: {
        '1': 0,
        '2': 1,
        '3': 1,
        '4': 1,
        '5': 1,
        '6': 1,
        '7': 1,
        '8': 1,
        '9': 1,
        '10': 1,
        '11': 1,
        '12': 1,
        '13': 0,
        '14': 0,
        '15': 0,
        '16': 1,
        '17': 1,
        '18': 1,
        '19': 1,
        '20': 0,
        '21': 0,
        '22': 0
      },
      loading: false,
      typeArr: [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24],
      disbaleArr: [1, 2, 3, 17, 18, 19, 20, 21, 23, 22, 24, 25],
      readonlyArr: [1, 2, 20, 21, 19, 21, 25, 25, 3],
      dialogFormVisibleArr: [{ visible: false }],
      dialogEventFormVisibleArr: [
        [{ visible: false }]
      ],
      total: 0,
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      },
      getVTitle(v) {
        if (v === 3) {
          return '点数'
        }
        return '权重'
      },
      selectType: [],
      rewardType: [],
      formData: [
        {
          'levelId': 0,
          'desc': '描述',
          'pro': [
            {
              'type': 1,
              'v': 0,
              'event': [
                {
                  'eventId': 0,
                  'v': 1,
                  'rewardId': 0,
                  'rewardNum': 0
                }
              ],
              'iconId': 0
            }
          ]
        }
      ],
      formInline: [],
      enums: ['攻击', '偷袭', '体力', '护盾', '1个金币', '2个金币', '3个金币', '1个钱袋', '2个钱袋', '3个钱袋', '没有奖励', '活动物品1', '活动物品2', '活动物品3', '小玩法物品1', '小玩法物品2', '小玩法物品3', '一个偷', '两个偷', '一个打', '两个打']
    }
  },
  created() {
    this.getTables()
    this.getRewardTypeData()
    this.getChessBoardType()
  },
  methods: {
    handleClose(done, index) {
      this.dialogFormVisibleArr[index].visible = false
      done()
    },
    weightIsReadOnly(v) {
      if (this.typeArr.includes(v)) {
        return true
      }
      return false
    },
    isReadOnly(v) {
      if (this.readonlyArr.includes(v)) {
        return true
      }
      return false
    },
    isDisabled(v) {
      if (this.disbaleArr.includes(v)) {
        return true
      }
      return false
    },
    getChessBoardType() {
      getChessBoardType().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.selectType.push({ 'title': res.data[i], 'id': parseInt(i) })
          }
        }
      })
    },
    getRewardTypeData() {
      getRewardType().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.rewardType.push({ 'label': res.data[i], 'value': parseInt(i), disabled: false })
          }
        }
      })
    },
    onSubmit() {
      const data = JSON.stringify(this.formData)
      console.log(data)
      updateSlotEventCfg({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    addLevel() {
      this.formData.push({
        'levelId': 0,
        'desc': '描述',
        'pro': []
      })
      const index = this.formData.length - 1
      this.dialogFormVisibleArr.push({ visible: false })
      this.$set(this.dialogEventFormVisibleArr, index, [])
      this.dialogEventFormVisibleArr[index].push({ visible: false })
      const pro = []
      this.selectType.forEach((item, i) => {
        pro.push({
          'type': item.id,
          'v': 0,
          'desc': '',
          event: []
        })
        this.dialogEventFormVisibleArr[index].push({ visible: false })
      }
      )
      this.formData[index].pro = pro
      this.selectType.forEach((item, i) => {
        this.selectTypeChange(item.id, index, i)
      })
    },
    confirm(index) {
      this.dialogFormVisibleArr[index].visible = false
      this.onSubmit()
    },
    add(index) {
      // console.log(this.formData[index])
      if (this.formData[index].pro.length > 40) {
        this.msgError('已达上限')
        return false
      }
      this.formData[index].pro.push({
        'type': 1,
        'v': 0,
        'desc': '描述',
        'event': [
          {
            'id': 1,
            'eventId': 1,
            'v': 0,
            'rewardId': 0,
            'rewardNum': 0
          }, {
            'id': 2,
            'eventId': 2,
            'v': 0,
            'rewardId': 0,
            'rewardNum': 0
          }
        ],
        'iconId': 0
      })
      this.dialogEventFormVisibleArr[index].push({ visible: false })
    },
    del(index, key) {
      this.formData[index].pro = this.formData[index].pro.filter((item, i) => {
        return i !== key
      })
    },
    getTables() {
      getSlotEventCfgList(this.queryParams).then(res => {
        this.total = res.data.count
        res.data.list.forEach((item, index) => {
          // 添加新的响应式属性到 this.dialogFormVisibleArr
          Vue.set(this.dialogFormVisibleArr, index, { visible: false })

          // 创建一个新的空数组
          const proArr = []

          // 遍历 item.pro，并将每个元素添加到 proArr
          item.pro.forEach(pro => {
            proArr.push({ visible: false })
          })

          // 添加新的响应式属性到 this.dialogEventFormVisibleArr
          Vue.set(this.dialogEventFormVisibleArr, index, proArr)
        })
        this.formData = res.data.list
      })
    },
    exportData() {
      exportSlotWeightEventCfg().then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    importUploadSuccess(response, file, fileList) {
      this.loading = true
      this.$refs.upload.clearFiles()
      importSlotWeightEventCfg({ path: response.data.path }).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    importMoneyUploadSuccess(response, file, fileList) {
      importSlotWeightCfg({ path: response.data.path, ImportType: 2 }).then(res => {
        // eslint-disable-next-line eqeqeq
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    exportMoney() {
      exportSlotWeightCfgMoney().then(res => {
        console.log(res)
      })
    },
    addEvent(index) {
      this.formData[index].pro.event.push({
        'eventId': 2,
        'v': 0
      })
    },
    removeEvent(index, key) {
      this.formData[index].slotPro.event = this.formData[index].slotPro.event.filter((item, k) => {
        return key !== k
      })
    },
    selectTypeChange(val, index, pIndex) {
      // console.log(val)
      // console.log(index)
      this.formData[index].pro[pIndex].event = []
      switch (val) {
        case 1:
          this.formData[index].pro[pIndex].event.push({
            'eventId': 1,
            'v': 1,
            'rewardId': 0,
            'rewardNum': 0
          })
          this.formData[index].pro[pIndex].event.push({
            'eventId': 2,
            'v': 1,
            'rewardId': 0,
            'rewardNum': 0
          })
          this.dialogFormVisibleArr.push({
            visible: false
          })
          break

        case 3:
          this.formData[index].pro[pIndex].event.push({
            'eventId': 3,
            'v': 1,
            'rewardId': 0,
            'rewardNum': 0
          })
          break

        case 4:
          this.formData[index].pro[pIndex].event.push({
            'eventId': 4,
            'v': 0,
            'rewardId': 0,
            'rewardNum': 0
          })
          break
        case 17:
        case 18:
        case 23:
        case 24:
          this.formData[index].pro[pIndex].event.push({
            'eventId': val,
            'v': 0,
            'rewardId': 14,
            'rewardNum': 0
          })
          break
        case 5:
        case 6:
        case 7:
        case 8:
        case 9:
        case 10:
        case 11:
        case 12:
        case 13:
        case 14:
        case 15:
        case 16:
        case 19:
          this.formData[index].pro[pIndex].event.push({
            'eventId': val,
            'v': 0,
            'rewardId': 0,
            'rewardNum': 0
          })
          break
        case 20:
        case 21:
        case 22:
          this.formData[index].pro[pIndex].event.push({
            'eventId': val,
            'v': 0,
            'rewardId': 0,
            'rewardNum': 0
          })
          break
      }
    }
  }
}
</script>

<style scoped>
</style>
